// AFTER SSL const basePath = 'http://62.72.58.202:1337'
const basePath = 'https://api.dutasaranakonstruksi.com'

module.exports.currencyFormat = function (value) {
  if (value === undefined || value === null) {
    return 'Rp 0'
  }
  return 'Rp ' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}

module.exports.getImage = function (imageName, section) {
  if (imageName === undefined || imageName === '' || imageName === null || section === undefined || section === '' || section === null) {
    return require('../assets/logo.png')
  }
  var defImage = require('../assets/defaultImage.jpeg')
  var image
  if (section === 'projects') {
    try {
      image = require('../assets/projects/' + imageName)
    } catch (err) {
      image = defImage
    }
  } else if (section === 'clients') {
    try {
      image = require('../assets/clients/' + imageName)
    } catch (err) {
      image = defImage
    }
  } else if (section === 'products') {
    try {
      image = require('../assets/products/' + imageName)
    } catch (err) {
      image = defImage
    }
  } else if (section === 'banner') {
    try {
      image = require('../assets/' + imageName)
    } catch (err) {
      image = defImage
    }
  } else if (section === 'url') {
    image = basePath + imageName
  }
  return image
}



// WEBPACK FOOTER //
// ./src/util/index.js